<template>
  <div>
    <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="item"
        :fields="fields"
        :items-per-page="small ? 50 : 20"
        :dark="dark"
        pagination
    >
      <template #index="{item,index}">
        <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
      </template>


      <template #title="{item,index}">
        <td  @click="toggleDetails(item, index)">
          <CRow>
            <CCol col="12">
              {{ item.title.filter(obj => { return (obj.key == lang) })[0].value }}
            </CCol>
          </CRow>
          <CRow v-for="objs in points">
            <CCol col="4">
              {{ objs.accounts.userinfo.prefix.filter(obj => { return (obj.key == lang) })[0].value }} {{objs.accounts.userinfo.firstName.filter(obj => { return (obj.key == lang) })[0].value}} {{ objs.accounts.userinfo.lastName.filter(obj => { return (obj.key == lang) })[0].value }}
            </CCol>
            <CCol col="8">
              <CIcon name="cil-star" size="lg" :class="'text-'+onCheckLevels(objs.objs[index],1)"/>
              <CIcon name="cil-star" size="lg" :class="'text-'+onCheckLevels(objs.objs[index],2)"/>
              <CIcon name="cil-star" size="lg" :class="'text-'+onCheckLevels(objs.objs[index],3)"/>
              <CIcon name="cil-star" size="lg" :class="'text-'+onCheckLevels(objs.objs[index],4)"/>
              <CIcon name="cil-star" size="lg" :class="'text-'+onCheckLevels(objs.objs[index],5)"/>

            </CCol>
          </CRow>
        </td>
      </template>





      <template #action="{item,index}">
        <td style="width: 140px">
          <CRow>
            <CCol class="text-center">
              <CButton class="mr-1"  size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                <CIcon name="cil-description"/>
              </CButton>

            </CCol>
          </CRow>
        </td>
      </template>


    </CDataTable>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";

export default {
  name: 'History',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    levels: {
      type: Number,
      default: 4
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    points:{
      type: Array,
      default: []
    },
    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          // {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          // {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"title", label:"Info",},
          // {key:"dateTime", label:"Last Update",  _style: 'width:190px;'},
          // {key:"action", label: "#", _style: 'width:50px; text-align: center'}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,




    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
    },

    onLoad() {

    },

    toggleDetails (item,index) {
      // item._toggled = !item._toggled
      // this.collapseDuration = 300
      // this.$nextTick(() => { this.collapseDuration = 0})

      this.$emit('info',item)
    },
    onCheckLevels(data,index){
      if(data >= index){
        if(index > this.levels){
          return "info"
        }else{
          return "success"
        }

      }else{
        if(index > this.levels){
          return "secondary"
        }else{
          return "danger"
        }
      }
    },

    onCheckLevel(data,index){
      var objs = data.item.reduce(function (sum, objs) { if(objs.checked === true){ return sum = sum+1; }else{ return sum; } }, 0);
      var total = data.item.length;
      var status = (objs == total)?true:false;

      if(index > this.levels){
        if(status == false){
          return "secondary"
        }else{
          return "info"
        }
      }else if(index == this.levels ){
        if(status == false){
          return "danger"
        }else {
          return "success"
        }
      }else{
        if(status == false){
          return "danger"
        }else{
          return "success"
        }
      }

      /*switch (index){*/
      /*  case 1:*/
      /*    if(index > this.levels && status == false){*/
      /*      return "danger"*/
      /*    }else if(index == this.levels && status == true){*/
      /*      return "success"*/
      /*    }else{*/
      /*      return "info"*/
      /*    }*/


      //     break;
      //   case 2:
      //     if(index > this.levels){
      //       return "success"
      //     }else if(index == this.levels){
      //       return "success"
      //     }else{
      //       return "info"
      //     }
      //     break;
      //   case 3:
      //     if(index > this.levels){
      //       return "success"
      //     }else if(index == this.levels){
      //       return "success"
      //     }else{
      //       return "info"
      //     }
      //     break;
      //   case 4:
      //     if(index > this.levels){
      //       return "success"
      //     }else if(index == this.levels){
      //       return "success"
      //     }else{
      //       return "info"
      //     }
      //     break;
      //   case 5:
      //     if(index > this.levels){
      //       return "success"
      //     }else if(index == this.levels){
      //       return "success"
      //     }else{
      //       return "info"
      //     }
      //     break;
      //
      // }
    }


  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
